import { slugify } from "@utils/utilsTestIds";

export interface FormTestId {
  id: string;
  testId: string;
}

export interface FormTestIds {
  fieldPrefix: (field: string) => string | undefined;
  selectOption: (field: string, rawValue: string) => FormTestId | undefined;
  uploadTestIds: (field: string) => FormTestId | undefined;
  multiTextAddTestIds: (field: string) => FormTestId | undefined;
  actionTestIds: (action: string) => FormTestId | undefined;
}

/**
 * Builds the set of test-id helpers for a form, given its prefix
 * (e.g. "edition-virtual-add-form"). When the prefix is missing each
 * helper returns undefined, leaving the components un-instrumented.
 */
export const createFormTestIds = (formPrefix?: string): FormTestIds => ({
  fieldPrefix: (field) => (formPrefix ? `${formPrefix}-${field}` : undefined),
  selectOption: (field, rawValue) => {
    if (!formPrefix) return undefined;
    const prefix = `${formPrefix}-${field}`;
    const type = slugify(`${rawValue}`.replace(/^DA_/i, ""));
    return { id: `${prefix}-option-${type}`, testId: `${prefix}-select` };
  },
  uploadTestIds: (field) =>
    formPrefix
      ? {
          id: `${formPrefix}-${field}-upload-button`,
          testId: `${formPrefix}-file-upload-trigger`,
        }
      : undefined,
  multiTextAddTestIds: (field) =>
    formPrefix
      ? {
          id: `${formPrefix}-${field}-add-button`,
          testId: `${formPrefix}-${field}-add-button`,
        }
      : undefined,
  actionTestIds: (action) =>
    formPrefix
      ? {
          id: `${formPrefix}-${action}-button`,
          testId: `${formPrefix}-fields-button-${action}`,
        }
      : undefined,
});
